import { Injectable } from '@angular/core';
import { ObjectTypes } from '../types';
import { FiBackendService } from '../fi-backend/fi-backend.service';
import { LoadingService } from '../fi-loading/loading.service';

@Injectable()
export class FiFavoritesService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    saveFavorite(objectId: number, objectType: ObjectTypes, trackPromise?: boolean) {
        const promise = this.fiBackend.fetchDataPost<void>('Core/Common/SaveFavorite', {
            ObjectId: objectId,
            ObjectType: objectType,
        });
        return trackPromise ? this.fiLoading.trackPromise(promise) : promise;
    }

    deleteFavorite(objectId: number, objectType: ObjectTypes, trackPromise?: boolean) {
        const promise = this.fiBackend.fetchDataPost<void>('Core/Common/DeleteFavorite', {
            ObjectId: objectId,
            ObjectType: objectType,
        });
        return trackPromise ? this.fiLoading.trackPromise(promise) : promise;
    }

    saveFavorites(objectType: ObjectTypes, objectIds: number[]) {
        return this.fiLoading.trackPromise(this.setFavorite(objectType, objectIds, []));
    }

    deleteFavorites(objectType: ObjectTypes, objectIds: number[]) {
        return this.fiLoading.trackPromise(this.setFavorite(objectType, [], objectIds));
    }

    private setFavorite(objectType: ObjectTypes, saveFavoritesObjects: number[], deleteFavoritesObjects: number[]) {
        return this.fiBackend.fetchDataPost('Core/Common/SetFavorite', {
            ObjectType: objectType,
            SaveFavorites: saveFavoritesObjects,
            DeleteFavorites: deleteFavoritesObjects,
        });
    }
}
